import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Image } from "antd";

const CommentImageSlideGroup = ({ imageList, type }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const user = useSelector((state) => state.auth.user);
	const userId = reduxChannel?.user_id
		? reduxChannel.user_id
		: user?.role === "level_1" || user?.role === "super_admin"
		? user?.id
		: user?.partners_id;

	const [imageSrcList, setImageSrcList] = useState([]);

	useEffect(() => {
		if (imageList?.length) {
			setImageSrcList(imageList);
		}
	}, [imageList]);

	return (
		// <Carousel afterChange={onChange} className={`image-slide-group`}>
		<div className={`image-slide-group`}>
			{imageSrcList?.map((img, idx) => (
				<div
					key={`comment-image-div-${idx}`}
					style={{
						width: "50%",
					}}
				>
					{img?.title && img?.img_type && (
						<Image
							preview={{
								// visible: false,
								mask: <></>,
								// current: index,
								// countRender: (c,t) => console.log(c, t)
							}}
							src={
								img?.target_type?.includes("mission")
									? `${
											process.env.REACT_APP_S3_LONGLIFE_HOST
									  }/images/mission/${img?.target_type?.replace(
											"mission-",
											""
									  )}/${img?.title}.${img?.img_type}`
									: `${process.env.REACT_APP_S3_HOST}/image/together/${
											type ? type : "comment"
									  }/${userId}/${img?.title}.${img?.img_type}`
							}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null; // prevents looping
								// currentTarget.style.display = "none";
								currentTarget.src = `/assets/images/no-product.png`;
							}}
							alt={`게시판 이미지`}
							// style={imageStyle}
						/>
					)}

					{/*<img*/}
					{/*    // preview={{*/}
					{/*    //     // visible: false,*/}
					{/*    //     mask: <></>,*/}
					{/*    //     // current: index,*/}
					{/*    //     // countRender: (c,t) => console.log(c, t)*/}
					{/*    // }}*/}
					{/*    src={`${process.env.REACT_APP_S3_HOST}/image/together/${type ? type : "comment"}/${userId}/${img?.title}.${img?.img_type}`}*/}
					{/*    onError={({currentTarget}) => {*/}
					{/*        currentTarget.onerror = null; // prevents looping*/}
					{/*        // currentTarget.style.display = "none";*/}
					{/*        // currentTarget.src = `/assets/images/no-product.png`;*/}
					{/*    }}*/}
					{/*    alt={`게시판 이미지`}*/}
					{/*    // style={imageStyle}*/}
					{/*/>*/}
				</div>
			))}
		</div>
		// </Carousel>
	);
};
export default CommentImageSlideGroup;
